export default {"src":"/_next/static/media/sitterdog.4bb82d2a.svg","height":64,"width":86,"blurWidth":0,"blurHeight":0};